import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-16dc7dde.js';
import { i as isV3, s as scrollToComponent } from './lookups-705fb53e.js';
import { j as join } from './path-9b025204.js';
import { E as EAvailabilityType, a as EApcButtonType, o as ETabType } from './request.constants-deb285e0.js';
import { c as classnames } from './index-136476ff.js';
import { a as isMobile } from './utils-15ad90ec.js';
import { s as setStickyBarTab, o as observeIntersectionWithHeader, a as setTabActive } from './stickyBar.utils-09e3b4ce.js';
import { E as ECarouselRelation } from './types-8e186e36.js';
import { a as addToCart, g as getApcCta, b as availabilityUrl, c as getAvailabilityInfo, f as formCtaUrl } from './api-413e09d4.js';
import './analytics-765d4daf.js';
import './_commonjsHelpers-ba3f0406.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';
import './ResizeObserver-f193871f.js';
import './http-fdc7ba18.js';
import './isEmpty-b60327cb.js';
import './isTypedArray-dfccd669.js';
import './controller-0b53c447.js';
import './format-string-a043c0ab.js';
import './toString-da636857.js';

const productsFiltersCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.product-container{padding:20px 30px;display:flex;flex-direction:column;background-color:#ffffff;border:1px solid #e7e6e6;margin-bottom:10px}@media screen and (min-width: 980px){.product-container{width:780px;flex-direction:row}}.cta-area__price .cta-price__text{width:100%}:host(:not([dir=\"rtl\"])) .cta-area__price .cta-price__text{text-align:right}:host([dir=\"rtl\"]) .cta-area__price .cta-price__text{text-align:left}.product-card{display:flex;flex-direction:column;flex-grow:1}@media screen and (min-width: 980px){.price-cta-container{width:24%}:host(:not([dir=\"rtl\"])) .price-cta-container{margin-left:30px}:host([dir=\"rtl\"]) .price-cta-container{margin-right:30px}}.content{max-width:1200px;margin:0 -16px;padding:0 20px}@media screen and (min-width: 980px){.content{padding:56px 10px 72px;display:flex}}@media screen and (min-width: 1230px){.content{margin:0 auto}}.product-card>a{text-decoration:none}.section_header{width:100%;margin-bottom:20px}@media screen and (min-width: 980px){.section_header{max-width:300px;width:25%}}.section_content{padding-top:20px}:host{background-color:#ffffff;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}@media screen and (min-width: 980px){:host{width:100%;display:block}}@media screen and (min-width: 980px){.section_filter{padding-top:20px}}.sortBylb{display:none}@media screen and (min-width: 980px){.sortBylb{margin-bottom:10px;display:inline-block;font-size:14px}:host(:not([dir=\"rtl\"])) .sortBylb{margin-right:6px}:host([dir=\"rtl\"]) .sortBylb{margin-left:6px}}.section_header_title{color:#b10043;font-size:25px}@media screen and (min-width: 980px){.section_header_title{white-space:initial;font-size:30px}:host(:not([dir=\"rtl\"])) .section_header_title{padding-right:20px}:host([dir=\"rtl\"]) .section_header_title{padding-left:20px}}.product-card-text{text-decoration:none;color:#42b4e6;font-weight:400;font-size:16px}.product-card-name{margin:0;color:#626469;font-weight:700;padding-top:18px;padding-bottom:10px;font-size:16px;word-break:break-word}@media screen and (min-width: 980px){.product-card-name{padding-top:10px}}.specifications__view-more-wrapper{text-align:center;font-size:16px}@media screen and (min-width: 980px){.specifications__view-more-wrapper{padding-bottom:20px;text-align:center}}";

let PesProductsFilter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.apcCtaButtonDidClick = createEvent(this, "apcCtaButtonDidClick", 7);
    this.setTabActive = createEvent(this, "setTabActive", 7);
    this.selectedCategoryProducts = [];
    this.categoryData = [];
    this.products = [];
    this.isExpanded = false;
    this.showViewMoreLabel = true;
    this.isMobile = isMobile();
    this.defaultRecordCount = 2;
    this.isAPCSite = false;
    this.loading = true;
    this.commerceConnectorSettings = null;
    this.giftId = null;
    this.host = '';
    this.renderViewMore = () => {
      return (this.showViewMoreLabel && (h("div", { class: "specifications__view-more-wrapper" }, h("pes-view-more-link", { viewMoreLabel: `${this.showMoreLabel} (${this.selectedCategoryProducts.length - this.defaultRecordCount})`, viewLessLabel: this.showLessLabel, isExpanded: this.isExpanded, iconSize: this.isMobile ? 'micro' : 'small' }))));
    };
    this.getApcPrices = (productId) => {
      var _a, _b;
      if (!productId) {
        return null;
      }
      if (!((_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b[productId])) {
        return null;
      }
      const { priceLabel, previousPriceValue, VATInclused, previousPrice, activePrice, activePriceNoTax, activePriceValue, } = this.productAvailabilityInfo.prices[productId];
      return {
        priceLabel,
        previousPriceValue,
        VATInclused,
        previousPrice,
        activePrice,
        activePriceNoTax,
        activePriceValue,
      };
    };
    this.getActivePrice = (productId) => {
      if (this.isAPCSite) {
        return this.renderApcPrices(productId);
      }
    };
    this.renderSectionContent = () => {
      return (h("div", { class: "section_content" }, this.products.map((product) => (h("div", { class: "product-container" }, h("div", { class: "product-card" }, h("a", { href: product.productUrl }, h("span", { class: "product-card-text" }, product.description), h("p", { class: "product-card-name" }, product.name))), this.productAvailabilityInfo && (h("div", { class: "price-cta-container" }, this.renderPrices(product.name), this.renderCTAArea(product.name))))))));
    };
    this.getButtonType = (productId) => {
      var _a, _b;
      const availabilityType = ((_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.availability) === null || _b === void 0 ? void 0 : _b[productId !== null && productId !== void 0 ? productId : '']) || null;
      switch (availabilityType) {
        case EAvailabilityType.ADD_TO_CART:
        case EAvailabilityType.PURCHASE_CD:
          return EApcButtonType.ADD_TO_CART;
        default:
          return null;
      }
    };
    this.handleClick = (event, productId) => {
      var _a, _b, _c, _d;
      addToCart(event, productId, this.getLocaleCodes(), (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.apcHost, (_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.failedResponse, this.agentChatCscId);
    };
  }
  getProductIds() {
    return this.data.map((item) => item.name).join('%7C');
  }
  onCcGetOptionsSucceeded(event) {
    if (event.detail.isApcSite && event.detail.apcCtaUrl) {
      const { isApcSite, apcCtaUrl, agentChatCscId } = event.detail;
      this.isAPCSite = isApcSite;
      this.apcCtaUrl = apcCtaUrl;
      this.agentChatCscId = agentChatCscId;
      if (this.isAPCSite && this.apcCtaUrl) {
        this.requestApcCta(this.apcCtaUrl);
      }
    }
  }
  componentDidLoad() {
    var _a;
    if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.length))
      return;
    this.setupTabbar();
  }
  getLocaleCodes() {
    const locale = document.querySelector('body').getAttribute('locale');
    const [languageCode, contryCode] = locale.split('_');
    return contryCode && languageCode
      ? join('/', contryCode.toLowerCase(), languageCode.toLowerCase())
      : '';
  }
  async requestApcCta(apcCtaUrl) {
    if (isV3()) {
      const locale = document.querySelector('body').getAttribute('locale');
      const [languageCode, countryCode] = locale.split('_');
      const params = {
        countryCode: countryCode.toLowerCase(),
        languageCode,
      };
      this.apcCta = await getApcCta(formCtaUrl(apcCtaUrl, params));
      return;
    }
    this.apcCta = await getApcCta(this.getLocaleCodes() + apcCtaUrl);
    this.requestProductAvailabilityInfo();
  }
  async requestProductAvailabilityInfo() {
    var _a, _b, _c;
    if ((_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls.apcHost) {
      const requestUrl = availabilityUrl((_c = (_b = this.apcCta) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.apcHost, this.getLocaleCodes(), this.getProductIds());
      this.productAvailabilityInfo = await getAvailabilityInfo(requestUrl);
    }
  }
  componentWillLoad() {
    this.categoryData = [{ label: this.selectLabel, value: '' }];
    this.categoryData.push(...new Map(this.data.map((item) => [
      item.category,
      { label: item.categoryLabel, value: item.category },
    ])).values());
    this.categoryData.sort((a, b) => a.value.localeCompare(b.value));
    this.loadInitialRecords();
  }
  setupTabbar() {
    setStickyBarTab(ETabType.LIFECYCLE_CAROUSEL, [this.sectionTitle]);
    this.observe();
  }
  handleTabClicked(event) {
    if (this.productsfilterRef && event.detail.type === ETabType.LIFECYCLE_CAROUSEL) {
      scrollToComponent(this.productsfilterRef);
    }
  }
  observe() {
    observeIntersectionWithHeader(this.productsfilterRef, (entries) => {
      var _a;
      if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
        setTabActive({ type: ETabType.LIFECYCLE_CAROUSEL, title: this.sectionTitle });
        this.setTabActive.emit();
      }
    });
  }
  getMapping(type) {
    const stickyBarMapping = {
      [ECarouselRelation.Compatiblesoftware]: ETabType.SOFTWARE_CAROUSEL,
      [ECarouselRelation.crossSellLife]: ETabType.LIFECYCLE_CAROUSEL,
      [ECarouselRelation.upsell]: ETabType.EXPLORE_CAROUSEL,
      [ECarouselRelation.crosssell]: ETabType.FREQUENTLY_BOUGHT_CAROUSEL,
    };
    return stickyBarMapping[type];
  }
  getDefaultCount(data) {
    return this.defaultRecordCount !== -1 ? this.defaultRecordCount : data.length;
  }
  loadInitialRecords() {
    this.products = this.data.slice(0, this.getDefaultCount(this.data));
    this.selectedCategoryProducts = JSON.parse(JSON.stringify(this.data));
  }
  handleToggleViewMore(e) {
    this.isExpanded = e.detail;
    if (!(this.isExpanded && this.showViewMoreLabel)) {
      this.productsfilterRef.scrollIntoView(true);
      this.products = this.selectedCategoryProducts.slice(0, this.getDefaultCount(this.selectedCategoryProducts));
    }
    else {
      this.products = JSON.parse(JSON.stringify(this.selectedCategoryProducts));
    }
  }
  changeCategory(selectedCategory) {
    if (selectedCategory.detail.selectedValue !== '') {
      this.selectedCategoryProducts = this.data.filter((item) => item.category === selectedCategory.detail.selectedValue);
    }
    else {
      this.selectedCategoryProducts = JSON.parse(JSON.stringify(this.data));
    }
    if (!this.isExpanded) {
      this.products = this.selectedCategoryProducts.slice(0, this.getDefaultCount(this.data));
    }
    else {
      this.products = JSON.parse(JSON.stringify(this.selectedCategoryProducts));
    }
  }
  renderApcPrices(productId) {
    var _a, _b;
    const prices = this.getApcPrices(productId);
    return (prices && (h("pes-cta-price", { previousPriceVariant: "beside", class: "cta-area__price_filter", priceHTML: prices.activePrice, previousPriceHTML: prices.previousPrice, vatLabel: (prices === null || prices === void 0 ? void 0 : prices.VATInclused) ? (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.vatLabel : '', variant: "list" })));
  }
  renderPrices(productId) {
    if (this.isAPCSite) {
      return (h("div", { class: classnames('prices', this.isMobile && 'prices--mobile') }, this.getActivePrice(productId)));
    }
  }
  renderApcAddToCartButton(productId) {
    var _a, _b;
    const addToCartButtonLabel = ((_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.addToCartButtonLabel) || 'Add to Cart';
    return (this.getButtonType(productId) && (h("pes-cta-button", { class: "cta-area__button", type: "primary", size: "medium", onDidClick: (event) => this.handleClick(event.detail, productId) }, addToCartButtonLabel)));
  }
  renderPrimaryCTA(productId) {
    if (this.isAPCSite) {
      if (this.productAvailabilityInfo && this.getButtonType(productId)) {
        return this.renderApcAddToCartButton(productId);
      }
    }
  }
  renderCTAArea(productId) {
    return (h("div", { class: "cta-area" }, h("div", { class: "cta-area__buttons" }, this.renderPrimaryCTA(productId))));
  }
  render() {
    var _a;
    if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.length))
      return null;
    return (h(Host, null, h("div", { class: "content" }, h("div", { class: "section_header" }, h("h2", { class: "section_header_title" }, this.sectionTitle)), h("div", { class: "section_filter" }, h("span", { class: "sortBylb" }, !this.isMobile && `${this.sortByLabel}`), h("pes-select", { items: this.categoryData, onSelectedValue: (value) => this.changeCategory(value) }), this.renderSectionContent(), this.selectedCategoryProducts.length > this.defaultRecordCount
      && this.renderViewMore()))));
  }
  get productsfilterRef() { return getElement(this); }
};
PesProductsFilter.style = productsFiltersCss;

export { PesProductsFilter as pes_products_filter };
